var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18C7.86312 18 5.85413 17.1679 4.34313 15.6569C2.83213 14.1459 2 12.1369 2 10C2 7.86312 2.83216 5.85416 4.34313 4.34313C5.85409 2.83209 7.86312 2 10 2C12.1369 2 14.1459 2.83213 15.6569 4.34313C17.1679 5.85413 18 7.86312 18 10C18 12.1369 17.1678 14.1458 15.6569 15.6569C14.1459 17.1679 12.1369 18 10 18ZM10 3C6.14019 3 3 6.14019 3 10C3 13.8598 6.14019 17 10 17C13.8598 17 17 13.8598 17 10C17 6.14019 13.8598 3 10 3Z",
    fill: "#F77E0B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.5C9.31075 9.5 8.75 8.93925 8.75 8.25C8.75 7.56075 9.31075 7 10 7C10.6892 7 11.25 7.56075 11.25 8.25C11.25 8.52612 11.4738 8.75 11.75 8.75C12.0262 8.75 12.25 8.52612 12.25 8.25C12.25 7.18122 11.5007 6.28475 10.5 6.05669V5.5C10.5 5.22387 10.2762 5 10 5C9.72384 5 9.5 5.22387 9.5 5.5V6.05669C8.49931 6.28475 7.75 7.18122 7.75 8.25C7.75 9.49066 8.75934 10.5 10 10.5C10.6892 10.5 11.25 11.0608 11.25 11.75C11.25 12.4392 10.6892 13 10 13C9.31075 13 8.75 12.4392 8.75 11.75C8.75 11.4739 8.52616 11.25 8.25 11.25C7.97384 11.25 7.75 11.4739 7.75 11.75C7.75 12.8188 8.49931 13.7153 9.5 13.9433V14.5C9.5 14.7761 9.72384 15 10 15C10.2762 15 10.5 14.7761 10.5 14.5V13.9433C11.5007 13.7153 12.25 12.8188 12.25 11.75C12.25 10.5093 11.2407 9.5 10 9.5Z",
    fill: "#F77E0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.46cb2f7ed7ab704ad99d1a6728f559c7.svg";
export { ForwardRef as ReactComponent };